import React from "react";

const EmbeddedScreenComponent = () => {
    return (
        <div>
            Embedded Screen
        </div>
    )
};

export default EmbeddedScreenComponent;